function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { DatePicker as AntdDatePicker } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { getValue } from "../DatePicker";
import getRangePresets from "../QuicklyItems";
import { DATE_RANGE, dateValueDisplay, DEFAULT_VALUE_FORMAT, MAX_DATE, MIN_DATE } from "../utils";
var AntdRangePicker = AntdDatePicker.RangePicker;
var DateRangePicker = function DateRangePicker(props) {
  var onChange = props.onChange,
    disabled = props.disabled,
    readOnly = props.readOnly,
    allowClear = props.allowClear,
    value = props.value,
    size = props.size,
    minDate = props.minDate,
    maxDate = props.maxDate,
    showQuicklyItems = props.showQuicklyItems,
    showTime = props.showTime,
    _props$picker = props.picker,
    picker = _props$picker === void 0 ? 'date' : _props$picker,
    _props$formatType = props.formatType,
    formatType = _props$formatType === void 0 ? DATE_RANGE : _props$formatType,
    _props$presetsType = props.presetsType,
    presetsType = _props$presetsType === void 0 ? DATE_RANGE : _props$presetsType;
  var format = useMemo(function () {
    return {
      format: DEFAULT_VALUE_FORMAT[formatType] || DEFAULT_VALUE_FORMAT.DATE_TIME,
      type: 'mask'
    };
  }, [formatType]);
  var rangePresets = useMemo(function () {
    return getRangePresets(presetsType);
  }, [presetsType]);
  var minDateVal = useMemo(function () {
    return getValue(minDate);
  }, [minDate]);
  var maxDateVal = useMemo(function () {
    return getValue(maxDate);
  }, [maxDate]);
  var valueVal = useMemo(function () {
    return [getValue(value === null || value === void 0 ? void 0 : value[0]), getValue(value === null || value === void 0 ? void 0 : value[1])];
  }, [value]);
  var allowEmpty = useMemo(function () {
    return [false, true];
  }, []);
  var handleChange = useCallback(function (_dates, dateStrings) {
    onChange === null || onChange === void 0 || onChange(dateStrings);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(AntdRangePicker, {
    allowClear: allowClear,
    size: size,
    disabled: disabled,
    readOnly: readOnly,
    minDate: minDateVal,
    maxDate: maxDateVal,
    value: valueVal,
    onChange: handleChange,
    allowEmpty: allowEmpty,
    presets: showQuicklyItems ? rangePresets : undefined,
    format: format,
    showTime: showTime,
    picker: picker
  });
};
export var DateRangePickerItem = function DateRangePickerItem(props) {
  var size = props.size,
    _props$value = props.value,
    value = _props$value === void 0 ? [] : _props$value,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '请选择' : _props$placeholder,
    disabled = props.disabled,
    readOnly = props.readOnly,
    onChange = props.onChange,
    _props$minDate = props.minDate,
    minDate = _props$minDate === void 0 ? MIN_DATE : _props$minDate,
    _props$maxDate = props.maxDate,
    maxDate = _props$maxDate === void 0 ? MAX_DATE : _props$maxDate,
    className = props.className,
    _props$allowClear = props.allowClear,
    allowClear = _props$allowClear === void 0 ? true : _props$allowClear,
    showQuicklyItems = props.showQuicklyItems,
    showTime = props.showTime,
    _props$picker2 = props.picker,
    picker = _props$picker2 === void 0 ? 'date' : _props$picker2,
    _props$formatType2 = props.formatType,
    formatType = _props$formatType2 === void 0 ? DATE_RANGE : _props$formatType2,
    _props$presetsType2 = props.presetsType,
    presetsType = _props$presetsType2 === void 0 ? DATE_RANGE : _props$presetsType2;
  if (readOnly) {
    var _dateValueDisplay = dateValueDisplay(value, props, formatType),
      _dateValueDisplay$dis = _dateValueDisplay.displayValue,
      displayValue = _dateValueDisplay$dis === void 0 ? [] : _dateValueDisplay$dis;
    var _ref = displayValue,
      _ref2 = _slicedToArray(_ref, 2),
      v1 = _ref2[0],
      v2 = _ref2[1];
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, v1 || '无', " - ", v2 || '无');
  }
  return /*#__PURE__*/React.createElement(DateRangePicker, {
    size: size,
    disabled: disabled,
    minDate: minDate,
    maxDate: maxDate,
    placeholder: placeholder,
    readOnly: readOnly,
    allowClear: allowClear,
    showQuicklyItems: showQuicklyItems,
    value: value,
    onChange: onChange,
    showTime: showTime,
    picker: picker,
    formatType: formatType,
    presetsType: presetsType
  });
};
export default DateRangePicker;